export class UtilisateurOption {
  constructor(
    public id?: number,
    public optionIdentifier?: string,
    public optionValue?: string,
  ) { }
}
